import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './aiAssistantSlice';

const selectSlice = (state: RootState) => state.aiAssistant || initialState;

export const selectMessages = createSelector(
  [selectSlice],
  state => state.messages
);
export const selectConversationId = createSelector(
  [selectSlice],
  state => state.conversationId
);
export const selectRuntimeSessionId = createSelector(
  [selectSlice],
  state => state.runtimeSessionId
);
export const selectIsStreaming = createSelector(
  [selectSlice],
  state => state.isStreaming
);
export const selectError = createSelector([selectSlice], state => state.error);
export const selectActiveTool = createSelector(
  [selectSlice],
  state => state.activeTool
);
export const selectThinkingText = createSelector(
  [selectSlice],
  state => state.thinkingText
);
export const selectExternalContext = createSelector(
  [selectSlice],
  state => state.externalContext
);
